import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">用户评价</h2>
          <p className="mt-2 text-sm text-foreground-600">来自真实用户的使用反馈</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-[960px] mx-auto">
          {commentItems.map((comment) => (
            <div
              key={comment.id}
              className="flex gap-4 p-5 bg-background-100 rounded-lg border border-background-200"
            >
              <div className="flex-shrink-0 w-11 h-11 rounded-full overflow-hidden bg-background-200">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <span className="text-xs text-foreground-500">{comment.date}</span>
                </div>
                <div className="flex items-center gap-0.5 mt-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <span key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                    </span>
                  ))}
                </div>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}